const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "MFName",
		label: "公司",
		columnwidth: 250,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 80,
	},
	{
		prop: "SalesManName",
		label: "销售员",
		columnwidth: 100,
	},
	{
		prop: "ProviderName",
		label: "经销商名称",
		columnwidth: 230,
	},
	{
		prop: "InvNameString",
		label: "授权产品",
		columnwidth: 300,
	},
	{
		prop: "AuthorityCode",
		label: "授权编号",
		columnwidth: 130,
	},
	{
		prop: "IsUploadFileName",
		label: "是否上传盖章文件",
		columnwidth: 130,
	},
	{
		prop: "StartDate",
		label: "授权有效期（开始）",
		columnwidth: 170,
	},
	{
		prop: "EndDate",
		label: "授权有效期（结束）",
		columnwidth: 170,
	},
	{
		prop: "Memo",
		label: "备注",
		columnwidth: 200,
	},
	{
		prop: "StatusName",
		label: "状态",
		columnwidth: 100,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 95,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 110,
	},
	{
		prop: "Operate",
		label: "操作",
		columnwidth: 180,
		fixed: "right",
	},
];
export default headerData;